import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';

import { Routes } from '../../../Routes';
import { Point, Wave, Circle } from '../../util/draw';
import { isPointInCircle, isMobile } from '../../util';

class Canvas extends Component {

  constructor(props) {
    super(props);

    // Present time value. 60 ticks = 1 sec
    this.ticks = 0;
    // One canvas is used only for the pencil drawing 
    // and the other one for the rest of the animations,
    // in order to not redraw the pencil drawing
    // on each frame.
    this.canvas = null;
    this.ctx = null;
    this.canvasPencil = null;
    this.ctxP = null;
    this.canvasRect = null;
    // Elements renderd on the canvas 
    this.start = null;
    this.end = null;
    this.waveOne = null;
    this.waveTwo = null;
    // Mouse cursor circle & props
    this.cursor = null;
    this.mouseX = 0;
    this.mouseY = 0;
    this.dX = 0;
    this.dY = 0;
    this.xPos = 0;
    this.yPos = 0;
    //
    this.keyStart = false;
    this.keyEnd = false;
    this.pencilOn = false;
    // Mouse coords for pencil drawing
    this.lastX = 0;
    this.lastY = 0;
    // Reference to the set interval function which 
    // will reneder the animations on canvas.
    this.interval = null;

    // Is not called on mount
    this.props.history.listen((location) => {
      // Reset timeline animation to 0 on every page change
      this.ticks = 0;
      this.keyStart = false;
      this.keyEnd = false;
      this.pencilOn = false;
      this.ctxP.clearRect(0, 0, window.innerWidth, window.innerHeight);
      // I found no way to hook in after the route change.
      // At the time this function is called, the new route
      // template is not yet rendered, so a timeout of 
      // 50 ms is needed.
      if (location.pathname !== '/economiseste-energie') {
        setTimeout(this.init, 50);
      }

    });

  }


  componentDidMount = () => {
    this.canvasPencil.width = this.canvas.width = window.innerWidth - 63;
    this.canvasPencil.height = this.canvas.height = window.innerHeight;

    this.ctxP = this.canvasPencil.getContext('2d');
    this.ctx = this.canvas.getContext('2d');

    this.canvasRect = this.canvas.getBoundingClientRect();

    if (isMobile) {

      this.canvas.ontouchstart = this.mouseDownHandler;
      this.canvas.ontouchmove = this.mouseMoveHandler;
      this.canvas.ontouchend = this.mouseUpHandler;

    } else {

      this.canvas.onmousedown = this.mouseDownHandler;
      this.canvas.onmouseup = this.mouseUpHandler;
      this.canvas.onmousemove = this.mouseMoveHandler;
    }



    this.cursor = Circle({ x: 0, y: 0, radius: 58, color: '#757575' });
    this.init();
  }

  mouseDownHandler = (e) => {
    // Clear the path painted before
    this.ctxP.clearRect(0, 0, window.innerWidth, window.innerHeight);
    this.cursor.resetShrink();
    // User has started drawing
    this.pencilOn = true;

    this.lastX = e.pageX - this.canvasRect.left;
    this.lastY = e.pageY - this.canvasRect.top;

    this.keyStart = isPointInCircle({ circle: this.start.center, e, canvasRect: this.canvasRect });
    if (this.keyStart) {
      this.waveOne.setPos({ x: this.end.center.x, y: this.end.center.y });
      this.waveTwo.setPos({ x: this.end.center.x, y: this.end.center.y });
    }
  }

  mouseUpHandler = (e) => {
    // Stop drawing
    this.pencilOn = false;
    this.keyEnd = isPointInCircle({ circle: this.end.center, e, canvasRect: this.canvasRect })
    if (this.keyStart) {
      this.cursor.resetAppear();
    }
    if (this.keyEnd && this.keyStart) {
      // remove waves from view
      this.waveOne.setPos({ x: window.innerWidth + 300, y: window.innerHeight + 300 });
      this.waveTwo.setPos({ x: window.innerWidth + 300, y: window.innerHeight + 300 });

      setTimeout(
        () => this.props.history.push(Routes[this.props.routeKey + 1].path),
        500
      );

    } else {
      this.waveOne.setPos({ x: this.start.center.x, y: this.start.center.y });
      this.waveTwo.setPos({ x: this.start.center.x, y: this.start.center.y });
    }

    this.keyStart = false;
  }

  mouseMoveHandler = (e) => {
    // Set the mouse coords relative to the canvas.
    const pageX = e.pageX || e.touches[0].clientX;
    const pageY = e.pageY || e.touches[0].clientY;

    this.mouseX = pageX - this.canvasRect.left;
    this.mouseY = pageY - this.canvasRect.top;

    if (this.pencilOn) {
      this.pencilDraw({ mouseX: this.mouseX, mouseY: this.mouseY });
    }

  }

  pencilDraw = ({ mouseX, mouseY }) => {


    // Find all points between        
    let x1 = mouseX;
    let x2 = this.lastX;
    let y1 = mouseY;
    let y2 = this.lastY;
    let steep = (Math.abs(y2 - y1) > Math.abs(x2 - x1));
    let x, y;

    if (steep) {
      x = x1;
      x1 = y1;
      y1 = x;

      y = y2;
      y2 = x2;
      x2 = y;
    }
    if (x1 > x2) {
      x = x1;
      x1 = x2;
      x2 = x;

      let y = y1;
      y1 = y2;
      y2 = y;
    }
    const dx = x2 - x1;
    const dy = Math.abs(y2 - y1);
    let error = 0;
    const de = dy / dx;
    let yStep = -1;
    y = y1;

    if (y1 < y2) {
      yStep = 1;
    }

    for (let x = x1; x < x2; x++) {
      if (steep) {
        this.ctxP.beginPath();
        this.ctxP.fillRect(y, x, 1, 1);
      } else {
        this.ctxP.fillRect(x, y, 1, 1);
      }

      error += de;
      if (error >= 0.5) {
        y += yStep;
        error -= 1.0;
      }
    }

    this.lastX = mouseX;
    this.lastY = mouseY;
  }

  Animation = () => {
    this.ctx.clearRect(0, 0, window.innerWidth, window.innerHeight);

    this.ticks += 1;
    const intro = 4.65;
    const delay = .8;

    // cursor
    if (!isMobile) {
      this.dX = this.mouseX - this.xPos;
      this.dY = this.mouseY - this.yPos;
      this.xPos += (this.dX / 10);
      this.yPos += (this.dY / 10);
      if (this.keyStart) {
        this.cursor.disappear(this.ctx)
      } else {
        this.cursor.setPos({ x: this.xPos, y: this.yPos }).appear(this.ctx);
      }
    }



    // navigation
    if (this.ticks > intro * 60) {
      if (!isMobile) {
        this.start.init(this.ctx);
        this.end.init(this.ctx);
      }


      this.waveOne.draw(this.ctx);
      if (this.ticks > (intro + delay) * 60) {
        this.waveTwo.draw(this.ctx);
      }
    }

  };

  init = () => {
    let start;
    let end;
    if (this.props.history.location.pathname === '/intro') {
      // Set Intro fallback
      start = {
        x: window.innerWidth / 2 - 20,
        y: window.innerHeight - 200
      };
      end = {
        x: window.innerWidth / 2 - 20,
        y: window.innerHeight - 50
      }
    } else if (this.props.history.location.pathname === '/campanie-arctic-enel') {
      start = {
        x: - 300,
        y: - 300
      };
      end = {
        x: - 300,
        y: - 3000
      }
    } else {
      // All pages but Intro have a point start & end
      start = document.querySelectorAll('.point-start circle')[0].getBoundingClientRect();
      end = document.querySelectorAll('.point-end circle')[0].getBoundingClientRect();


    }

    this.start = Point({
      x: start.x,
      y: start.y,
      radius: 20,
      isFilled: true
    });

    this.end = Point({
      x: end.x,
      y: end.y,
      radius: 20,
      isFilled: true
    });

    this.waveOne = Wave({
      x: start.x,
      y: start.y,
      apex: (30 + (30 / 1.5) * 1.6),
      speed: 1
    });

    this.waveTwo = Wave({
      x: start.x,
      y: start.y,
      apex: (30 + (30 / 1.5) * 1.6),
      speed: 1
    });

    if (this.interval) {
      clearInterval(this.interval)
      this.interval = setInterval(this.Animation, 1000 / 60);
    } else {
      this.interval = setInterval(this.Animation, 1000 / 60);
    }
  }

  render() {
    return (
      <span style={{ position: 'absolute', top: 0, left: 0, zIndex: 1000 }}>
        <canvas style={{ position: 'absolute', top: 0, left: 0, zIndex: 1001 }} ref={(node) => this.canvas = node} />
        <canvas style={{ position: 'absolute', top: 0, left: 0, zIndex: 1000 }} ref={(node) => this.canvasPencil = node} />
      </span>
    );
  }

}

export default withRouter(Canvas);




// WEBPACK FOOTER //
// ./src/components/theme/Canvas/Canvas.jsx